import { render, staticRenderFns } from "./WhiteButton.vue?vue&type=template&id=3fb4d626&"
import script from "./WhiteButton.vue?vue&type=script&lang=js&"
export * from "./WhiteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports